<template>
  <IndexPageSection
    :link-string="'一覧へ'"
    :link-url="'/scenes'"
    :need-link="needListLink"
    :need-to-move-link-to-bottom="false"
    :section-name="'scene-list-section'"
    :title="'シーンから探す'"
    :link-data-gtm-page="dataGtmPage"
    :link-data-gtm-click="dataGtmPage ? 'scene_list' : null"
  >
    <div v-if="isScenesLoading" class="scene-list-section__loading">
      <Loading />
    </div>
    <HorizontalScroll v-else ref="scene-list-horizontal" ref-name="scene-list">
      <SceneList
        :scenes="scenes"
        :data-gtm-page="dataGtmPage"
        :data-gtm-click="dataGtmPage ? 'scene' : null"
        @mount="onMountSceneList"
        @click-scene="onClickScene"
      />
    </HorizontalScroll>
  </IndexPageSection>
</template>
<script>
import qs from 'qs'
import IndexPageSection from './IndexPageSection.vue'
import SceneList from './scenes/SceneList.vue'
import Loading from '../../../atoms/loadings/Loading.vue'
import axios from 'axios'
import HorizontalScroll from '../../../molecules/horizontal-scrolls/HorizontalScroll.vue'

export default {
  components: { HorizontalScroll, IndexPageSection, SceneList, Loading },
  props: {
    needListLink: {
      type: Boolean,
      required: false,
      default: true
    },
    itemLinkBasePath: {
      type: String,
      required: false,
      default: ''
    },
    itemLinkParams: {
      type: Object,
      required: false,
      default: () => ({})
    },
    dataGtmPage: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      scenes: [],
      isScenesLoading: false
    }
  },
  mounted() {
    this.getScenes()
  },
  methods: {
    async getScenes() {
      this.isScenesLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/scenes')
        this.scenes = res.data.data
          .map(scene => scene.attributes)
          .map(({ id, name, top_image_url }) => {
            const paramsString = qs.stringify(
              {
                scene_id: id,
                ...this.itemLinkParams
              },
              { arrayFormat: 'brackets' }
            )

            return {
              id,
              name,
              imageUrl: top_image_url,
              linkUrl: `${this.itemLinkBasePath}/items?${paramsString}`
            }
          })
        this.isScenesLoading = false
      } catch (error) {
        this.isScenesLoading = false
        const message =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', message)
      }
    },
    onMountSceneList() {
      this.$refs['scene-list-horizontal'].initializeValues()
    },
    onClickScene(sceneId) {
      this.$emit('click-scene', sceneId)
    }
  }
}
</script>
